'use client';

import React, { FC } from 'react';
import IBlockCounts from '~/data/strapi/types/single-types/main-page/block-counts';
import useIsVisible from '~/hooks/use-is-visible';

import NumbersItem from './count-item';
import CountsPattern from './pattern';
import styles from './styles.module.css';

interface Props {
  data: IBlockCounts;
}

const BlockCounts: FC<Props> = ({ data }) => {
  const { projectsCount, citiesCount, yearsCount } = data;

  const { ref, isVisible } = useIsVisible<HTMLDivElement>();

  return (
    <div className={styles.container}>
      <div className={styles.numbersContainer} ref={ref}>
        {projectsCount && (
          <NumbersItem
            maxCounter={projectsCount}
            titles={['проект', 'проекта', 'проектов']}
            isShowAnimation={isVisible}
          />
        )}
        {citiesCount && (
          <NumbersItem maxCounter={citiesCount} titles={['город', 'города', 'городов']} isShowAnimation={isVisible} />
        )}

        {yearsCount && (
          <NumbersItem
            maxCounter={yearsCount}
            titles={['год опыта', 'года опыта', 'лет опыта']}
            isShowAnimation={isVisible}
          />
        )}

        <CountsPattern />
      </div>
    </div>
  );
};

export default BlockCounts;
